import {
  loadingFailAction,
  loadingStartAction,
  loadingSuccessAction,
} from "@wisr/common";
import { Epic, ofType } from "redux-observable";
import { concat, of } from "rxjs";
import {
  catchError,
  concatMap,
  mapTo,
  tap,
  withLatestFrom,
} from "rxjs/operators";

import { redirect } from "../shared/browser.utils";
import { LOAN_OFFER_PAGE } from "../shared/url.consts";
import { AppAction, AppStore } from "../store";
import {
  ApplicationClearStateActionType,
  ApplicationGetContinueTokenActionType,
  applicationGetContinueTokenSuccessAction,
} from "./application-form.actions";
import { getContinueToken } from "./application-form.service";

export const GET_APPLICATION_LOADING = "GET_APPLICATION_LOADING";
export const getApplicationContinueTokenEpic: Epic<AppAction> = (actions) =>
  actions.pipe(
    ofType(ApplicationGetContinueTokenActionType),
    concatMap((action) =>
      concat(
        of(loadingStartAction(GET_APPLICATION_LOADING)),
        getContinueToken(action.token).pipe(
          tap(({ continueToken }) =>
            window.sessionStorage.setItem("ContinueToken", continueToken)
          ),
          concatMap(({ continueToken }) => [
            applicationGetContinueTokenSuccessAction(continueToken),
            loadingSuccessAction(GET_APPLICATION_LOADING),
          ])
        )
      )
    ),
    catchError(() => {
      return of(loadingFailAction(GET_APPLICATION_LOADING, "Unexpected Error"));
    })
  );

export const SAVE_APPLICATION_LOADING = "SAVE_APPLICATION_LOADING";

export const clearApplicationEpic: Epic<AppAction, AppAction, AppStore> = (
  actions,
  store
) =>
  actions.pipe(
    ofType(ApplicationClearStateActionType),
    withLatestFrom(store),
    concatMap(([action, state]) =>
      concat(
        of([action, state]).pipe(
          tap(() => {
            if (action.redirect) {
              if (action.editing && action.term) {
                redirect(
                  `${LOAN_OFFER_PAGE}?qid=${state.applicationFormState.quoteRefId}&editing=${action.editing}&term=${action.term}`
                );
              } else {
                redirect(
                  `${LOAN_OFFER_PAGE}?qid=${state.applicationFormState.quoteRefId}`
                );
              }
            }
          }),
          mapTo(loadingSuccessAction(SAVE_APPLICATION_LOADING))
        )
      )
    )
  );
